var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReply(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 336.009V456.002C512 469.251 501.25 480 488 480S464 469.251 464 456.002V336.009C464 278.669 417.344 232.016 360 232.016H88.506L215.688 341.853C225.719 350.508 226.812 365.664 218.156 375.694C213.406 381.194 206.719 384.006 200 384.006C194.438 384.006 188.844 382.1 184.312 378.163L8.312 226.173C3.031 221.611 0 214.986 0 208.018C0 201.049 3.031 194.425 8.312 189.863L184.312 37.873C194.312 29.154 209.469 30.279 218.156 40.341C226.812 50.372 225.719 65.527 215.688 74.183L88.506 184.019H360C443.812 184.019 512 252.202 512 336.009Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReply);
export default __webpack_public_path__ + "static/media/reply.97d4764fb9bd53e6419ca1af68d9062b.svg";
export { ForwardRef as ReactComponent };